import * as React from "react";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import { CommonProjectChannelOverview } from "../../CommonComponents/CommonProjectChannelViews";
export const ProjectChannelRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.project().channel,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonProjectChannelOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => null,
};
